import cn from "../../../utils/cn";
import PropTypes from 'prop-types';
import Divider from "../../Display/Divider/Divider";
import DraftEditorField from "../../Form/DraftEditorField/DraftEditorField";
import ExpandableContainer from "../../Display/ExpandableContainer/ExpandableContainer";
import LabelTextInline from "../../utils/LabelTextInline/LabelTextInline";
import { FormattedMessage } from 'react-intl';
import stateEnums from "../../utils/Programs/stateEnums";
import ageRangeConverters from "../../utils/Ages/ageRangeConverters";
import { isEligTextEmpty } from "../../utils/Programs/checkEmptyText";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ProgramEligibility = _ref => {
  var _requirements$filter;
  let {
    className = "",
    program: {
      accessibility_options,
      delivery_options,
      description,
      eligibility_text,
      languages,
      payment_options,
      population_specializations,
      population_restrictions,
      transportation_options,
      age_requirements,
      age_specializations,
      requirements,
      postal_code_requirements,
      state_requirements,
      county_requirements,
      city_requirements
    },
    showLess = false,
    showMore = false
  } = _ref;
  const {
    processAgeText,
    convertApiAgeRangeToUnits
  } = ageRangeConverters;
  const countyRequirments = county_requirements === null || county_requirements === void 0 ? void 0 : county_requirements.map(r => r.name.concat(", ", r.state)).join("; ");
  const cityRequirements = city_requirements === null || city_requirements === void 0 ? void 0 : city_requirements.map(r => r.name.concat(", ", r.state)).join("; ");
  const postalCodeRequirements = postal_code_requirements === null || postal_code_requirements === void 0 ? void 0 : postal_code_requirements.map(r => r.postal_code);
  const transformedStateRequirements = state_requirements === null || state_requirements === void 0 ? void 0 : state_requirements.map(s => stateEnums.states[s.id]);
  const transformedAgeRequirements = age_requirements ? processAgeText(...convertApiAgeRangeToUnits(age_requirements)) : null;
  const transformedAgeSpecializations = age_specializations ? processAgeText(...convertApiAgeRangeToUnits(age_specializations)) : null;
  const genderRequirements = requirements === null || requirements === void 0 || (_requirements$filter = requirements.filter(r => r.category === "gender")) === null || _requirements$filter === void 0 ? void 0 : _requirements$filter.map(r => r.display_name);
  const hasRegionalElig = Boolean([...(postal_code_requirements || []), ...(state_requirements || []), ...(county_requirements || []), ...(city_requirements || [])].length !== 0);
  const eligTextEmpty = isEligTextEmpty(eligibility_text);
  return /*#__PURE__*/_jsxs("div", {
    className: cn("text-text-blue", className),
    children: [/*#__PURE__*/_jsx("div", {
      className: cn({
        hidden: eligTextEmpty
      }),
      children: /*#__PURE__*/_jsxs(ExpandableContainer, {
        collapsedHeight: "70px",
        id: "program-eligibility-expandable",
        controlled: true,
        isOpen: showMore,
        hideToggle: true,
        showGradient: showLess,
        children: [/*#__PURE__*/_jsx("h4", {
          className: "mb-2 font-heavy-font",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            id: "Tl36ae",
            description: "eligibility",
            defaultMessage: "Eligibility"
          })
        }), /*#__PURE__*/_jsx(DraftEditorField, {
          hideLabel: true,
          id: "program-eligibility_text",
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            id: "Tl36ae",
            description: "eligibility",
            defaultMessage: "Eligibility"
          }),
          readOnly: true,
          value: eligibility_text || ""
        })]
      })
    }), eligTextEmpty && description && showLess ? /*#__PURE__*/_jsxs(ExpandableContainer, {
      collapsedHeight: "70px",
      id: "program-eligibility-expandable",
      controlled: true,
      isOpen: showMore,
      hideToggle: true,
      showGradient: showLess,
      children: [/*#__PURE__*/_jsx("h4", {
        className: "mb-4",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          id: "rT7jXR",
          description: "description",
          defaultMessage: "Description"
        })
      }), /*#__PURE__*/_jsx(DraftEditorField, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          id: "rT7jXR",
          description: "description",
          defaultMessage: "Description"
        }),
        hideLabel: true,
        id: "program-description-text",
        value: description,
        readOnly: true
      })]
    }) : null, hasRegionalElig && showMore ? /*#__PURE__*/_jsxs("div", {
      children: [eligTextEmpty ? null : /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx("h4", {
        className: "mb-4",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          id: "jwwDck",
          description: "clients-must-live-text",
          defaultMessage: "Client must live in the following..."
        })
      }), transformedStateRequirements && /*#__PURE__*/_jsx(LabelTextInline, {
        className: "mb-4",
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          id: "XW82Wp",
          description: "states",
          defaultMessage: "States"
        }),
        content: transformedStateRequirements
      }), (county_requirements === null || county_requirements === void 0 ? void 0 : county_requirements.length) > 0 && /*#__PURE__*/_jsx(LabelTextInline, {
        className: "mb-4",
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          id: "mZ2nD1",
          description: "counties",
          defaultMessage: "Counties"
        }),
        content: countyRequirments
      }), (city_requirements === null || city_requirements === void 0 ? void 0 : city_requirements.length) > 0 && /*#__PURE__*/_jsx(LabelTextInline, {
        className: "mb-4",
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          id: "Zonjcr",
          description: "cities",
          defaultMessage: "Cities"
        }),
        content: cityRequirements
      }), (postal_code_requirements === null || postal_code_requirements === void 0 ? void 0 : postal_code_requirements.length) > 0 && /*#__PURE__*/_jsx(LabelTextInline, {
        className: "mb-4",
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          id: "aDv4mN",
          description: "zip-codes",
          defaultMessage: "Zip codes"
        }),
        content: postalCodeRequirements
      })]
    }) : null, showMore && /*#__PURE__*/_jsxs("div", {
      children: [!eligTextEmpty || hasRegionalElig ? /*#__PURE__*/_jsx(Divider, {
        className: "my-5"
      }) : null, /*#__PURE__*/_jsx(LabelTextInline, {
        className: "mb-4 text-sm flex",
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          id: "zPsx0I",
          description: "populations-restriction",
          defaultMessage: "Populations restricted to"
        }),
        content: population_restrictions
      }), /*#__PURE__*/_jsx(LabelTextInline, {
        className: "mb-4 text-sm flex",
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          id: "sUXZue",
          description: "gender-requirements",
          defaultMessage: "Genders restricted to"
        }),
        content: genderRequirements
      }), /*#__PURE__*/_jsx(LabelTextInline, {
        className: "mb-4 text-sm flex",
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          id: "xByfh4",
          description: "age-requirements",
          defaultMessage: "Ages restricted to"
        }),
        content: transformedAgeRequirements
      }), /*#__PURE__*/_jsx(LabelTextInline, {
        className: "mb-4 text-sm flex",
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          id: "o0u6lY",
          description: "population-catered",
          defaultMessage: "Populations specialized in"
        }),
        content: population_specializations
      }), /*#__PURE__*/_jsx(LabelTextInline, {
        className: "mb-4 text-sm flex",
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          id: "XKOAjP",
          description: "age-specialization",
          defaultMessage: "Ages specialized in"
        }),
        content: transformedAgeSpecializations
      }), /*#__PURE__*/_jsx(LabelTextInline, {
        className: "mb-4 text-sm flex",
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          id: "RqjsZm",
          description: "languages",
          defaultMessage: "Languages"
        }),
        content: languages
      }), /*#__PURE__*/_jsx(LabelTextInline, {
        className: "mb-4 text-sm flex",
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          id: "lpYuHX",
          description: "transportation",
          defaultMessage: "Transportation"
        }),
        content: transportation_options
      }), /*#__PURE__*/_jsx(LabelTextInline, {
        className: "mb-4 text-sm flex",
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          id: "J9KLw4",
          description: "accessibility",
          defaultMessage: "Accessibility"
        }),
        content: accessibility_options
      }), /*#__PURE__*/_jsx(LabelTextInline, {
        className: "mb-4 text-sm flex",
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          id: "kCUBP8",
          description: "primary-service-delivery",
          defaultMessage: "Primary Method of Service Delivery"
        }),
        content: delivery_options
      }), /*#__PURE__*/_jsx(LabelTextInline, {
        className: "mb-4 text-sm flex",
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          id: "MIPeJV",
          description: "payment-options",
          defaultMessage: "Payment options"
        }),
        content: payment_options
      })]
    })]
  });
};
ProgramEligibility.propTypes = {
  className: PropTypes.string,
  showMore: PropTypes.bool,
  showLess: PropTypes.bool,
  program: PropTypes.object.isRequired
};
export default ProgramEligibility;
//# sourceMappingURL=ProgramEligibility.js.map